import actionTypes from 'src/modules/redux/actionTypes'

export const setSavedFilters =
(savedFilters) => ({
  type: actionTypes.SET_SAVED_FILTERS,
  payload: {savedFilters}
}) 